import { defineAsyncComponent } from 'vue'
export default {
  "standalone-snowplow-layout": defineAsyncComponent(() => import("/codebuild/output/src2821564992/src/layouts/StandaloneSnowplowLayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src2821564992/src/layouts/default.vue").then(m => m.default || m))
}